/* Rquiere de mixin.js */

var employee = {
	data () {
		return {
			employeeIdSelected: 0,
			listEmployees: [],
			methodsEmployee: {
                show: 'employee/',
                get: 'employees',
                create: 'employee/register',
				delete: '/delete',
                update: '/update'
			},
			paginationEmployees: [],
            searchEmployees: '',
            objectEmployee: {
				exist: 0,
				id: 0,
				name: '',
				surname: '',
				date_birth: '',
				document_number: '',
				country_id: 0,
				country: {},
				status_id: 0,
				status: {},
				created_at: '',
				updated_at: ''
			},
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
        clearObjectEmployee() {
            this.objectEmployee.exist = 0
            this.objectEmployee.id = 0
            this.objectEmployee.name = ''
            this.objectEmployee.surname = ''
            this.objectEmployee.date_birth = ''
            this.objectEmployee.document_number = ''
            this.objectEmployee.country_id = 0
            this.objectEmployee.country = {}
            this.objectEmployee.status_id = 0
            this.objectEmployee.status = {}
            this.objectEmployee.created_at = ''
            this.objectEmployee.updated_at = ''
		},
        getAllEmployees(page = 1) {
			let parameters = '?search=' + this.searchEmployees + '&page=' + page
			let url = this.getApiBackend + this.methodsEmployee.get + parameters
			this.axiosActionIS(url, 'GET', 'getAllEmployeesResult')
        },
		getAllEmployeesResult(response) {
			if(response.data.success == true) {
				this.listEmployees = response.data.data
				this.paginationEmployees = response.data.paginate
			}
			this.getAllEmployeesResultLocal(response)
        },
		getAllEmployeesResultLocal(response) {
			console.log('getAllEmployeesResultLocal no desarrollado', response)
		},
		getEmployeesByDepartament(departamentId) {
            let param = '?assets=' + true
            let url = this.getApiBackend + 'department/' + departamentId + '/employees'
			this.axiosActionIS(url, 'GET', 'getAllEmployeesResult')
        },
        setObjectEmployee(item) {
			let newItem = Object.create(item)
			for (const property in newItem) {
				this.objectEmployee[property] = newItem[property]
			}
        },
    },
};

export default employee;